<template>
  <!-- {{ item }} -->
  <div
    class="p-[15px] my-2 rounded-lg border-1 cursor-pointer transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white ">
    <div
      class="relative grid grid-cols-4 tablet:grid-cols-6 tablet:landscape:grid-cols-7 laptop:grid-cols-12 largeDesktop:grid-cols-12 gap-2 laptop:gap-1.5 largeDesktop:gap-2.5 break-words">
      <div class="col-span-2 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">Invoice
          ID:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] font-normal underline cursor-pointer text-[#0d6efd]" v-html="item.po_invoice_id"></p>
      </div>
      <div class="col-span-2 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1 tablet:hidden">
        <div class="flex justify-end">
          <p v-if="item.action_status == 'Paid'"
            class="inline-block text-center py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#B6CE35]">
            Paid</p>
            <p v-else-if="item.action_status == 'Payment Failed'"
                class="inline-block text-center py-[1px] px-[10px] text-[14px] laptop:text-[12px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#DB2777]">
                Payment Failed</p>
          <p v-else-if="item.status_slug == 'Un-Paid'"
            class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#f00]">
            Unpaid</p>
          <p v-else>-</p>
        </div>
      </div>
      <div class="col-span-4 tablet:col-span-2 laptop:col-span-2 largeDesktop:col-span-3 relative group">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">
          Order Number:
        </span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] font-normal block">
          {{ item.order_number }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 tablet:landscape:col-span-2 tablet:landscape:pl-[30px] largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">Created
          Date:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] font-normal">
          {{ $helper.isEmpty(item.created_at) ? '-' : $helper.formattedDate(item.created_at) }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">Paid
          Date:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] font-normal">
          {{ $helper.isEmpty(item.paid_date) ? '-' : $helper.formattedDate(item.paid_date) }}
        </p>
      </div>
      <div class="col-span-2 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1 hidden tablet:block">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">
          Status:
        </span>
        <div>
          <p v-if="item.action_status == 'Paid'"
            class="inline-block text-center py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#B6CE35]">
            Paid</p>
            <p v-else-if="item.action_status == 'Payment Failed'"
                class="inline-block text-center py-[1px] px-[10px] text-[14px] laptop:text-[12px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#DB2777]">
                Payment Failed</p>
          <p v-else-if="item.status_slug == 'Un-Paid'"
            class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#f00]">
            Unpaid</p>
          <p v-else>-</p>
        </div>
      </div>
      <div class="col-span-4 tablet:col-span-3 laptop:col-span-2 largeDesktop:col-span-3 relative group">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">
          Service Address:
        </span>
        <!-- Show full name directly on mobile -->
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] font-normal block">
          {{ item.service_address }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-2 tablet:landscape:col-span-2 tablet:landscape:pl-[30px] largeDesktop:col-span-3 relative group">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">
          Payment Type:
        </span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] font-normal">
          {{ item.payment_type }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins text-[14px] largeDesktop:text-base inline-block">Amount:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] font-normal">
          ${{ $helper.isEmpty(item.invoice_amount) ? '-' : $helper.formatAmount(item.invoice_amount) }}
        </p>
      </div>

    </div>
  </div>
</template>
<script>

export default {
  props: ["item"],
  components: {
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getActions() {
      let res = ["Detail"]
      if (this.item.status_slug != "cancelled") {
        res.push("Cancel")
      }
      return res
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    select(value) {
      // this.selected = value;
      this.isOpen = false;
      this.$emit('update', this.item, value); // emit change if needed
    },

    getShortPlanName(name) {
      if (this.$helper.isEmpty(name)) return '-';
      return name.length > 30 ? name.substring(0, 30) + '...' : name;
    },

    handleClickOutside(event) {
      if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
        this.isOpen = false;
      }
    },

    getStatusImage(status) {
      switch (status) {
        case 'pending':
          return require('@/assets/images/pending-status.png');
        case 'approved':
          return require('@/assets/images/approved-green-icon.png');
        case 'rejected':
          return require('@/assets/images/reject-status.png');
        default:
          return require('@/assets/images/pending-status.png');
      }
    }
  }
};
</script>